// reducer/bookingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    service: '',
    serviceId: '',
    serviceType: '', // Array of objects
    dateAndTimeSlot: {
        selectedDate: null,
        selectedTimeSlot: null,
    },
    bookingDetails: [],
    payment: false, // Boolean indicating if payment is completed
};

const kiidoBookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setService(state, action) {
            state.service = action.payload;
        },
        setServiceId(state, action) {
            state.serviceId = action.payload;
        },
        setServiceType(state, action) {
            state.serviceType = action.payload;
        },
        setDateAndTimeSlot(state, action) {
            state.dateAndTimeSlot = action.payload;
        },
        setBookingDetails(state, action) {
            state.bookingDetails = action.payload
        },
        setPayment(state, action) {
            state.payment = action.payload;
        },
        resetBooking(state) {
            return initialState; // Reset to initial state
        },
    },
});

// Export actions
export const {
    setService,
    setServiceId,
    setServiceType,
    setDateAndTimeSlot,
    setBookingDetails,
    setPayment,
    resetBooking,
} = kiidoBookingSlice.actions;

// Export reducer
export default kiidoBookingSlice.reducer;
